export enum EAccountOrganizationStatus {
  ACTIVE = 'active',
  SUSPEND = 'suspend',
  BLOCKED = 'blocked'
}
